import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This is why I hate mornings",
  "description": "",
  "published": "2009-02-10T00:00:00.000Z",
  "redirect_from": ["/blog/this-is-why-i-hate-mornings/swizec/8"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I went to bed early with a terrible headache and a plan to get up early this morning so I could be home from work sooner than usual and make up for the studying lost last night because of the headache. That was the plan anyway, but instead I found myself in a three hour long phonecall with the lady, but alright, still went to sleep much earlier than usual (like an hour).`}</p>
    <p>{`So this morning my alarm goes off at eight, as usual. I moan something and don't even hear it, as usual. A few very persistant rings later I get up the courage to put it on snooze for, just five more minutes. As usual. After those five minutes are up I groan and put it on snooze for ... just five more minutes. As usual.`}</p>
    <p>{`Then after those five minutes are up, I crawl out of bed and go to the bathroom. Quite unusual, doing great. The bathroom door is ajar and the light and heating are already running. Oh cool, someone left all these things on for me because they knew I'd be getting up early. So I go inside and ... the alarm wakes me up. Oh fucking screw you!`}</p>
    <p>{`And I took the covers off. I did! I totally took them off planning to get up and go to work. After another five minutes of snoozing I pull the covers off completely and go to the bathroom. This time I remember to bring fresh pants with and there's no light running. The door is closed, the whole normal shebang. So I take a shower, dry myself and wake up in bed again ... wrapped under covers. How the fuck!?`}</p>
    <p>{`My fourth attempt, I think, memory's kind of foggy, I finally managed to get an actual shower and go to work. But by this time, of course, it was already well over ten in the morning, I came to work two hours late, which is a full hour later than usual and today isn't going to offer me nearly as much time to study as I'd hoped.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      